import React from 'react'
import { compose } from 'recompose'
import toFinalFormInput from '../FormElements/toFinalFormInput'
import { TextAreaField } from './styles'

const TextArea = props => <TextAreaField {...props} />

export const FinalTextArea = compose(toFinalFormInput)(TextArea)

export default TextArea



// WEBPACK FOOTER //
// ./src/Components/TextArea/TextArea.jsx